<p>{{ detailsPayload | sessionStatsPeriod | sessionStatsDisplayTitle }}</p>
@if (detailsPayload | sessionStatsDisplayRangeLabel; as displayRangeLabel) {
  <p>
    {{ displayRangeLabel }}
  </p>
}

@if (parsedDetails?.orders; as orders) {
  <h2>
    <span>{{ orders.count }}</span> zamowien o wartosci
    <span>{{ orders.total | currency: orders.currency }}</span>
  </h2>
}

@if (parsedDetails | sessionStatsTopOrderSessions; as topOrderSessions) {
  @if (topOrderSessions.length) {
    <div class="details">
      <h3>Sesje z najwieksza liczba zamowien</h3>
      <table>
        @for (session of topOrderSessions; track trackBySessionId($index, session)) {
          <tr>
            <td>
              <span>{{ session.count }}</span>
            </td>
            <td>
              <lib-quick-link
                [contextId]="session.id"
                [context]="session.context"
              ></lib-quick-link>
            </td>
            <td class="order-total">
              <strong>{{ session.totalsLabel }}</strong>
            </td>
          </tr>
        }
      </table>
    </div>
  }
}

@if (
  parsedDetails
  | sessionStatsTopPublicSessionOrganizationsByOrders; as topPublicSessionOrganizationsByOrders
  ) {
  @if (topPublicSessionOrganizationsByOrders.length) {
    <div class="details">
      <h3>Placowki z najwieksza liczba zamowien</h3>
      <table>
        @for (
          publicSessionOrganization of topPublicSessionOrganizationsByOrders; track trackById($index,
          publicSessionOrganization)) {
          <tr
            >
            <td>
              <span>{{ publicSessionOrganization.count }}</span>
            </td>
            <td>
              {{
              publicSessionOrganization.id | publicSessionOrganizationName | async
              }}
            </td>
            <td class="order-total">
              <strong>{{ publicSessionOrganization.totalsLabel }}</strong>
            </td>
          </tr>
        }
      </table>
    </div>
  }
}

@if (
  parsedDetails
  | sessionStatsTopPublicSessionOrganizationGroupsByOrders; as topPublicSessionOrganizationGroupsByOrders
  ) {
  @if (topPublicSessionOrganizationGroupsByOrders.length) {
    <div
      class="details"
      >
      <h3>Klasy z najwieksza liczba zamowien</h3>
      <table>
        @for (
          publicSessionOrganizationGroup of topPublicSessionOrganizationGroupsByOrders; track trackByPublicSessionOrganizationGroupId($index,
          publicSessionOrganizationGroup)) {
          <tr
            >
            <td>
              <span>{{ publicSessionOrganizationGroup.count }}</span>
            </td>
            <td>
              {{
              (publicSessionOrganizationGroup.publicSessionOrganizationId
              | publicSessionOrganizationName
              | async) ||
              publicSessionOrganizationGroup.publicSessionOrganizationId
              }}
              /
              {{
              (publicSessionOrganizationGroup.id
              | publicSessionOrganizationGroupName
              : publicSessionOrganizationGroup.publicSessionOrganizationId
              | async) || publicSessionOrganizationGroup.id
              }}
            </td>
            <td class="order-total">
              <strong>{{ publicSessionOrganizationGroup.totalsLabel }}</strong>
            </td>
          </tr>
        }
      </table>
    </div>
  }
}

@if (parsedDetails?.visits) {
  <div>
    <h2>
      Ilosc wizyt: <span>{{ parsedDetails.visits }}</span>
    </h2>
    @if (
      parsedDetails
      | sessionStatsVisits: orderContext.PublicSession; as publicSessionVisits
      ) {
      @if (publicSessionVisits.length) {
        <div class="details">
          <h3>Sesje publiczne</h3>
          <table>
            @for (session of publicSessionVisits; track trackBySessionId($index, session)) {
              <tr
                >
                <td>
                  <span>{{ session.count }}</span>
                </td>
                <td>
                  <lib-quick-link
                    [contextId]="session.id"
                    [context]="orderContext.PublicSession"
                  ></lib-quick-link>
                </td>
              </tr>
            }
          </table>
        </div>
      }
    }
    @if (
      parsedDetails
      | sessionStatsVisits
      : orderContext.PrivateSession; as privateSessionVisits
      ) {
      @if (privateSessionVisits.length) {
        <div class="details">
          <h3>Sesje prywatne</h3>
          <table>
            @for (
              session of privateSessionVisits; track trackBySessionId($index,
              session)) {
              <tr
                >
                <td>
                  <span>{{ session.count }}</span>
                </td>
                <td>
                  <lib-quick-link
                    [contextId]="session.id"
                    [context]="orderContext.PrivateSession"
                  ></lib-quick-link>
                </td>
              </tr>
            }
          </table>
        </div>
      }
    }
  </div>
}
